import { modalRoutes } from 'packages/route'
import { NestedRoute } from 'packages/route/components'

import { FormalUserLayout } from './FormalUserLayout'

/**
 * 门户前台
 *
 * @returns 定义
 */
export const Gateway: React.FC = () => <FormalUserLayout />
